// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2lLgI","list":"BalanceDue_list__18Uzo","listRow":"BalanceDue_listRow__3A4l-","total":"BalanceDue_total__i5opH"};